import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ColorPickerListItem from '../../../../../../list-items/ColorPickerListItem/ColorPickerListItem';

const LyricsShadowColorListItem = (props) => {
    const { shadowSettingsColor, updateLyricsStyle } = props;
    
    const onShadowColorChange = (color) => {
        var value = color.hex.replace('#', '0x');

        updateLyricsStyle({ 
            shadowSettings: { color: value } 
        });
    };
    
    return (
        <ColorPickerListItem
            text='Color'
            color={shadowSettingsColor.replace('0x', '#')}
            onChange={onShadowColorChange}
            disableAlpha={true}
        />
    );
};

const mapStateToProps = (state) => {
    const { shadowSettings } = state.createPreview.present.videoSettings.lyrics.style;
    const shadowSettingsColor = shadowSettings ? shadowSettings.color : "0x000000";
    return { shadowSettingsColor };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsShadowColorListItem);
